module.exports = __webpack_public_path__ + "img/InsightsSuccess.812677b3.jpg";